import { useQuery } from '@apollo/client'
import { Button, Card, Col, Row, Skeleton, Space, Spin, Typography, Collapse, Tabs } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { DOWNLOAD_RESOURCE, GET_RESOURCE } from '../../../graphql/query/organization'
import './styles.css'
import { IDownloadResourceResp, IResource } from '../../OrganizationDetails/types'
import { DownloadOutlined, LeftOutlined } from '@ant-design/icons'
import Header from '../../../components/Header/Header'
import { useEffect, useState } from 'react'
import { COMMON_CONSTANTS } from '../../../commonConstants'
import Status from '../helperComponents/StatusModal/Status'
import { downloadResourceFromUri } from '../../../utils/resourceUtils'
import { format } from 'date-fns-tz'

const AOIDetails = () => {
  const { Panel } = Collapse
  const navigate = useNavigate()
  const [isDownloading, setIsDownloading] = useState<boolean>(false)
  const [activeTab, setActiveTab] = useState<string>('comments')
  const { id } = useParams()
  const {
    data: resourceData,
    loading: aoiInfoLoading,
    error: aoiInfoError,
  } = useQuery(GET_RESOURCE, {
    variables: {
      resourceId: id,
    },
  })
  const AOIInfo: IResource = resourceData?.getResource
  const {
    data,
    loading: downloadResourceLoading,
    error,
  } = useQuery(DOWNLOAD_RESOURCE, {
    variables: {
      input: [
        {
          resourceId: id,
          version: AOIInfo?.versions?.[0]?.version ?? 1,
        },
      ],
    },
    skip: !isDownloading,
  })

  const downloadedResourceResp: Array<IDownloadResourceResp> = data?.downloadResource

  useEffect(() => {
    downloadResourceFromUri({
      downloadedResourceResp,
      isResourceDownloading: isDownloading,
      setIsResourceDownloading: setIsDownloading,
    })
  }, [downloadedResourceResp, isDownloading])

  const allVersions = AOIInfo?.versions
  const currentResourceVersion = allVersions?.[0]

  return (
    <>
      <Header>
        <Space
          direction="horizontal"
          size={'middle'}
          onClick={() => navigate(-1)}
          style={{ cursor: 'pointer' }}>
          <Typography.Link>
            <LeftOutlined style={{ verticalAlign: 'middle' }} />
          </Typography.Link>
          <div className="header-title">AOI Details</div>
        </Space>
      </Header>
      <Row style={{ padding: 24 }} align={'top'}>
        {aoiInfoLoading ? (
          <Row justify={'center'} align={'middle'} style={{ width: '100%' }}>
            <Skeleton.Button active style={{ height: 500 }} block />
          </Row>
        ) : (
          <>
            <Col span={16} style={{ paddingRight: 24 }}>
              <Space direction="vertical" style={{ width: '100%' }} size={'large'}>
                <Card style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 16,
                    }}>
                    <div className="aoi-details">
                      <Typography.Text>AOI File Name: </Typography.Text>
                      <Typography.Text className="detail-value">
                        {AOIInfo?.resourceKey}
                      </Typography.Text>
                    </div>
                    <div className="aoi-details">
                      <Typography.Text>Created At: </Typography.Text>
                      <Typography.Text className="detail-value">
                        {currentResourceVersion?.createdAt != null
                          ? format(
                              new Date(currentResourceVersion?.createdAt),
                              COMMON_CONSTANTS.dateFormat
                            )
                          : '-'}
                      </Typography.Text>
                    </div>
                    <div className="aoi-details">
                      <Typography.Text>Updated At: </Typography.Text>
                      <Typography.Text className="detail-value">
                        {currentResourceVersion?.updatedAt != null
                          ? format(
                              new Date(currentResourceVersion?.updatedAt),
                              COMMON_CONSTANTS.dateFormat
                            )
                          : '-'}
                      </Typography.Text>
                    </div>
                  </div>
                </Card>
                <Button
                  onClick={(e) => {
                    setIsDownloading(true)
                  }}
                  type={isDownloading ? 'default' : 'primary'}
                  title="Download AOI">
                  {isDownloading ? (
                    <Space direction="horizontal">
                      <Spin style={{ verticalAlign: 'middle' }} />
                      <Typography.Text>Downloading...</Typography.Text>
                    </Space>
                  ) : (
                    <Space direction="horizontal">
                      <DownloadOutlined />
                      Download
                    </Space>
                  )}
                </Button>
                <Tabs
                  defaultActiveKey={activeTab}
                  onChange={(activeKey) => setActiveTab(activeKey)}
                  type="card"
                  items={[
                    {
                      label: `Comments`,
                      key: 'comments',
                      children:
                        currentResourceVersion?.comments !== null ? (
                          <Typography.Text>
                            {currentResourceVersion?.comments === ''
                              ? 'No Comments'
                              : currentResourceVersion?.comments}
                          </Typography.Text>
                        ) : (
                          <Typography.Text>No Comments</Typography.Text>
                        ),
                    },
                  ]}
                />
              </Space>
            </Col>
            <Col span={8}>
              <Collapse defaultActiveKey={['1']}>
                <Panel header="Stage Overview" key="1">
                  {currentResourceVersion?.pipelineStatus && (
                    <Col style={{ padding: 12 }}>
                      <Status
                        showTitle={false}
                        fileStatus={currentResourceVersion?.pipelineStatus}
                      />
                    </Col>
                  )}
                </Panel>
              </Collapse>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

export default AOIDetails
